"use client";
import React from "react";
import { jobPostData } from "@/data/career.data";
import { FiMapPin } from "react-icons/fi";
import { RiBriefcase4Line } from "react-icons/ri";
import { TransitionLink } from "../shared/TransitionLink";
import { useDict } from "@/components/providers/LocaleProvider";

const JobPost = () => {
  const t = useDict();
  return (
    <section className=" space-y-6" id="career-job-posts">
      <h2 className="text-center  section-title">
        <strong className=" font-semibold ">
          {t.careersPage.jobPost.sectionTitle}
        </strong>
      </h2>
      <section className=" space-y-4">
        {jobPostData.length > 0 ? (
          jobPostData.map((job, index) => (
            <div
              key={index}
              className="p-5 rounded-lg border border-gray-500 md:flex md:justify-between md:items-center space-y-4"
            >
              <div className="md:mb-0">
                <p className="text-gray-200 text-xl mb-2">{job.position}</p>
                <section className="flex flex-col xl:flex-row xl:items-center gap-6">
                  <p className="flex items-center gap-2">
                    <FiMapPin />
                    {job.jobLocation}
                  </p>
                  <p className="flex items-center gap-2">
                    <RiBriefcase4Line />
                    {job.experience}
                  </p>
                </section>
              </div>
              <section className="flex flex-col gap-4 items-end">
                <p className="text-sm">
                  {t.careersPage.jobPost.deadlineLabel} {job.deadline}
                </p>
                <TransitionLink
                  title={job.position}
                  href={`/careers/${job.endpoint}`}
                  className="bg-primary text-white px-6 py-2 rounded-lg font-bold hover:bg-primary/80 cursor-pointer w-full md:w-auto"
                >
                  {t.careersPage.jobPost.applyNow}
                </TransitionLink>
              </section>
            </div>
          ))
        ) : (
          <div className="p-5 mb-4 rounded-lg border  min-h-[300px] flex flex-col justify-center items-center border-gray-500 text-center text-gray-200">
            <p className="text-xl mb-2">{t.careersPage.jobPost.noJobs}</p>
            <p className="text-sm">{t.careersPage.jobPost.noJobsHint}</p>
          </div>
        )}
      </section>
    </section>
  );
};

export default JobPost;
